// @ts-nocheck
import { usePaymetricFrame } from "@insite/client-framework/Common/Hooks/usePaymetricFrame";
import { BillingAddress, usePaystandFrame } from "@insite/client-framework/Common/Hooks/usePaystandFrame";
import { useSquareFrame } from "@insite/client-framework/Common/Hooks/useSquareFrame";
import {
    IFrame,
    TokenEx as TokenExType,
    TokenExIframeStyles,
    useTokenExFrame,
} from "@insite/client-framework/Common/Hooks/useTokenExFrame";
import StyledWrapper, { getStyledWrapper } from "@insite/client-framework/Common/StyledWrapper";
import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import { makeHandlerChainAwaitable } from "@insite/client-framework/HandlerCreator";
import { getAdyenSessionData, postAdyenRefund } from "@insite/client-framework/Services/PaymentService";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
// import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import loadAdyenSettings from "@insite/client-framework/Store/Context/Handlers/LoadAdyenSettings";
import loadPaymetricConfig from "@insite/client-framework/Store/Context/Handlers/LoadPaymetricConfig";
import loadTokenExConfig from "@insite/client-framework/Store/Context/Handlers/LoadTokenExConfig";
import signOut from "@insite/client-framework/Store/Context/Handlers/SignOut";
import { getBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import loadBillTo from "@insite/client-framework/Store/Data/BillTos/Handlers/LoadBillTo";
// import { getCartState, getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector"; // Starter Custom Code
import resetCurrentCartId from "@insite/client-framework/Store/Data/Carts/Handlers/ResetCurrentCartId";
import { getCurrentCountries } from "@insite/client-framework/Store/Data/Countries/CountriesSelectors";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import checkoutWithPayPal from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/CheckoutWithPayPal";
import getPaymetricResponsePacket from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/GetPaymetricResponsePacket";
import loadAdyenDropInConfig from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/LoadAdyenDropInConfiguration";
import placeOrder from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/PlaceOrder";
import setCheckoutPaymentMethod from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/SetCheckoutPaymentMethod";
import setPaymetricIFrameIsSet from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/SetPaymetricIFrameIsSet";
import setPlaceOrderErrorMessage from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/SetPlaceOrderErrorMessage";
import setPONumber from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/SetPONumber";
import setValidateForm from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/SetValidateForm";
import validateAdyenPayment, {
    ValidatAdyenPaymenteResult,
    ValidateAdyenPaymentParameter,
} from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/ValidateAdyenPayment";
import preloadOrderConfirmationData from "@insite/client-framework/Store/Pages/OrderConfirmation/Handlers/PreloadOrderConfirmationData";
import translate from "@insite/client-framework/Translate";
import { PaymentMethodDto } from "@insite/client-framework/Types/ApiModels";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";

import AdyenDropIn from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/AdyenDropIn";
import CreditCardBillingAddressEntry, {
    CreditCardBillingAddressEntryStyles,
} from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CreditCardBillingAddressEntry";
// import CreditCardDetailsEntry, {
//     CreditCardDetailsEntryStyles,
// } from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CreditCardDetailsEntry"; // Bunzl Custom Code
import ECheckDetailsEntry, {
    ECheckDetailsEntryStyles,
    Validatable,
} from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/ECheckDetailsEntry";
import PaymentProfileBillingAddress from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/PaymentProfileBillingAddress";
import PayPalButton, { PayPalButtonStyles } from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/PayPalButton";
import SavedPaymentProfileEntry, {
    SavedPaymentProfileEntryStyles,
    SavedPaymentProfileValidation,
} from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/SavedPaymentProfileEntry";
import { convertPaymetricCardType } from "@insite/content-library/Widgets/SavedPayments/PaymentUtilities";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import Select, { SelectPresentationProps } from "@insite/mobius/Select";
import { generateSpreedlyFrameStyleConfig } from "@insite/mobius/SpreedlyFrame";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import ToasterContext, { HasToasterContext, withToaster } from "@insite/mobius/Toast/ToasterContext";
// import { generateTokenExFrameStyleConfig } from "@insite/mobius/TokenExFrame"; // Starter Custom Code
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import VisuallyHidden from "@insite/mobius/VisuallyHidden";
import qs from "qs";
// import React, { useEffect, useRef, useState } from "react"; // Starter Custom Code
import { connect, ResolveThunks } from "react-redux";
import { css, ThemeProps, withTheme } from "styled-components";

/* Starter Custom Code */
import {
    canApplyPromotionsToCart,
    getCartState,
    getCurrentCartState,
} from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Block, { BlockProps } from "@store/Library/Components/Toolkit/Block";
import InfosBox, { InfosBoxProps } from "@store/Library/Components/Toolkit/InfosBox";
import Loader from "@store/Library/Components/Toolkit/Loader";
import { generateTokenExFrameStyleConfig } from "@store/MobiusOverrides/TokenExFrame/TokenExFrameStyleConfig";
import { formFieldButtonOffset } from "@store/Themes/common/mixins/formField";
import { orderProps } from "@store/Themes/common/props/order";
import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import getWidgetComponent from "@toolkit/Framework/Common/Utilities/getWidgetComponent";
import React, { useCallback, useEffect, useRef, useState } from "react";

// Bunzl
import { SpreedlyIframeStyles, useSpreedlyFrame } from "@insite/client-framework/Common/Hooks/useSpreedlyFrame";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import loadSpreedlyConfig from "@insite/client-framework/Store/Context/Handlers/LoadSpreedlyConfig";
import { getShipToState } from "@insite/client-framework/Store/Data/ShipTos/ShipTosSelectors";
import usePaymentDetailsCartState from "@insite/content-library/Hooks/Payments/usePaymentDetailsCartState";
import usePaymentDetailsFormHandlers from "@insite/content-library/Hooks/Payments/usePaymentDetailsFormHandlers";
import usePaymentDetailsFormState from "@insite/content-library/Hooks/Payments/usePaymentDetailsFormState";
import usePaymentDetailsFormValidation from "@insite/content-library/Hooks/Payments/usePaymentDetailsFormValidation";
import CreditCardDetailsEntry, {
    CreditCardDetailsEntryStyles,
    CreditCardDetailsValidation,
} from "@store/Overrides/Widgets/CheckoutReviewAndSubmit/CreditCardDetailsEntry";
import placeOrderForApprovalWithOptionalPoNumber from "@store/Extensions/Store/Pages/CheckoutReviewAndSubmit/PlaceOrderForApprovalWithOptionalPoNumber";
import useSignatureData from "@store/Framework/Common/Hooks/useSignatureData";
import { useIsMobileSalesAccount } from "@store/Framework/Store/Data/Accounts/Hooks/useIsMobileSalesAccount";
import { hasProductsWithInvalidPrice } from "@store/Framework/Store/Data/Carts/CartsSelector";
import { checkoutInputGridItemStyle } from "@store/Themes/common/props/checkout";

const PromotionCode = getWidgetComponent("CheckoutReviewAndSubmit/CheckoutReviewAndSubmitPromotionCode");

const enum fields {
    allowPromotionCode = "allowPromotionCode",
    // Bunzl;
    cardExpirationDateCondensed = "cardExpirationDateCondensed",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.allowPromotionCode]: boolean;
        // Bunzl
        [fields.cardExpirationDateCondensed]: boolean;
    };
}
// <-- Bunzl Custom Code

const mapStateToProps = (state: ApplicationState, ownProps: OwnProps /* Store Custom Code */) => {
    // Bunzl -->
    const {
        fields: { allowPromotionCode, cardExpirationDateCondensed },
    } = ownProps;
    const {
        cartId,
        payPalRedirectUri,
        payPalCheckoutErrorMessage,
        placeOrderErrorMessage,
        requestedPickUpDateDisabled,
        requestedDeliveryDateDisabled,
        paymetricIFrameIsSet,
        // Starter Custom Code
        isCheckingOutWithPayPay,
    } = state.pages.checkoutReviewAndSubmit;
    const cartState = cartId ? getCartState(state, cartId) : getCurrentCartState(state);
    const settingsCollection = getSettingsCollection(state);

    const billToState = getBillToState(state, cartState.value?.billToId);
    const shipToState = getShipToState(state, cartState.value?.shipToId);
    // <-- Bunzl
    return {
        cartState,
        billToState: getBillToState(state, cartState.value ? cartState.value.billToId : undefined),
        countries: getCurrentCountries(state),
        websiteSettings: settingsCollection.websiteSettings,
        cartSettings: settingsCollection.cartSettings,
        tokenExConfigs: state.context.tokenExConfigs,
        orderConfirmationPageLink: getPageLinkByPageType(state, "OrderConfirmationPage"),
        savedPaymentsPageLink: getPageLinkByPageType(state, "SavedPaymentsPage"),
        session: state.context.session,
        signInPageLink: getPageLinkByPageType(state, "SignInPage"),
        checkoutReviewAndSubmitPageLink: getPageLinkByPageType(state, "CheckoutReviewAndSubmitPage"),
        payPalRedirectUri,
        payPalCheckoutErrorMessage,
        location: getLocation(state),
        adyenSettings: state.context.adyenSettings,
        paymetricConfig: state.context.paymetricConfig,
        spreedlyConfig: state.context.spreedlyConfig,
        enableVat: settingsCollection.productSettings.enableVat,
        bypassCvvForSavedCards: settingsCollection.cartSettings.bypassCvvForSavedCards,
        placeOrderErrorMessage,
        requestedDeliveryDateDisabled,
        requestedPickUpDateDisabled,
        paymetricIFrameIsSet,
        // Starter Custom Code
        canApplyPromosToCart: canApplyPromotionsToCart(cartState.value) && !isCheckingOutWithPayPay,
        // Bunzl
        isSignatureRequired: settingsCollection.mobileSalesSettings.isSignatureRequired,
        cardExpirationDateCondensed,
        orderApprovalDetailsLink: getPageLinkByPageType(state, "OrderApprovalDetailsPage"),
        isDisabled:
            cartState.isLoading ||
            billToState.isLoading ||
            !billToState.value ||
            shipToState.isLoading ||
            !shipToState.value ||
            !billToState.value.address1 ||
            !shipToState.value.address1 ||
            isCheckingOutWithPayPay ||
            hasProductsWithInvalidPrice(cartState.value) ||
            cartState.value?.hasInsufficientInventory === true,
    };
};

const mapDispatchToProps = {
    placeOrderForApprovalWithOptionalPoNumber,
    loadTokenExConfig,
    placeOrder,
    checkoutWithPayPal,
    preloadOrderConfirmationData,
    loadBillTo,
    loadPaymetricConfig,
    loadAdyenSettings,
    loadAdyenDropInConfig,
    loadSpreedlyConfig,
    getPaymetricResponsePacket,
    resetCurrentCartId,
    setCheckoutPaymentMethod,
    signOut,
    validateAdyenPayment: makeHandlerChainAwaitable<ValidateAdyenPaymentParameter, ValidatAdyenPaymenteResult>(
        validateAdyenPayment,
    ),
    setPlaceOrderErrorMessage,
    setPaymetricIFrameIsSet,
    setPONumber,
    setValidateForm,
};

type Props = ReturnType<typeof mapStateToProps> &
    OwnProps & // Starter Custom Code
    ResolveThunks<typeof mapDispatchToProps> &
    ThemeProps<BaseTheme> &
    HasHistory &
    HasToasterContext;

export interface CheckoutReviewAndSubmitPaymentDetailsStyles {
    form?: InjectableCss;
    fieldset?: InjectableCss;
    paymentDetailsHeading?: TypographyPresentationProps;
    paymentMethodPayPalText?: TypographyPresentationProps;
    paymentMethodAndPONumberContainer?: GridContainerProps;
    paymentMethodGridItem?: GridItemProps;
    paymentMethodSelect?: SelectPresentationProps;
    paymentProfileBillingAddress?: any;
    paymentProfileExpiredErrorWrapper?: InjectableCss;
    paymentProfileExpiredErrorText?: TypographyPresentationProps;
    paymentProfileEditCardLink?: LinkPresentationProps;
    vatNumberGridItem?: GridItemProps;
    vatNumberText?: TextFieldPresentationProps;
    poNumberGridItem?: GridItemProps;
    poNumberText?: TextFieldPresentationProps;
    emptyGridItem?: GridItemProps;
    adyenDropInGridItem?: GridItemProps;
    mainContainer?: GridContainerProps;
    savedPaymentProfile?: SavedPaymentProfileEntryStyles;
    creditCardDetailsGridItem?: GridItemProps;
    paystandDetailsGridItem?: GridItemProps;
    eCheckDetailsGridItem?: GridItemProps;
    creditCardDetails?: CreditCardDetailsEntryStyles;
    creditCardAddressGridItem?: GridItemProps;
    creditCardAddress?: CreditCardBillingAddressEntryStyles;
    payPalButton?: PayPalButtonStyles;
    eCheckDetailsEntryStyles?: ECheckDetailsEntryStyles;
    paypalCheckoutErrorWrapper?: InjectableCss;
    paypalCheckoutErrorText?: TypographyPresentationProps;
    loadingSpinner?: LoadingSpinnerProps;
    // Starter Custom Code
    block?: BlockProps;
    errorInfosBox?: InfosBoxProps;
    subSection?: InjectableCss;
    promotionCodeGridItem?: GridItemProps;
    payPalButtonGridItem?: GridItemProps;
    paymentProfileDetailsHeading?: TypographyPresentationProps;
    paymentProfileDetailsContainer?: GridContainerProps;
    paymentProfileDetailsGridItem?: GridItemProps;
    paymentProfileAddressHeading?: TypographyPresentationProps;
    creditCardDetailsHeading?: TypographyPresentationProps;
    // Store Custom Code
    gridRow?: InjectableCss;
}

export const checkoutReviewAndSubmitPaymentDetailsStyles: CheckoutReviewAndSubmitPaymentDetailsStyles = {
    block: orderProps.block,
    subSection: orderProps.subSection,
    fieldset: {
        css: css`
            margin: 0;
            padding: 0;
            border: 0;
        `,
    },
    paymentDetailsHeading: orderProps.subtitle,
    paymentMethodAndPONumberContainer: orderProps.grid?.container,
    paymentProfileAddressHeading: orderProps.subSectionTitle,

    promotionCodeGridItem: {
        width: 12,
        css: css`
            display: block;
        `,
    },
    creditCardDetailsHeading: orderProps.subSectionTitle,
    paymentProfileDetailsHeading: orderProps.subSectionTitle,
    paymentProfileDetailsContainer: orderProps.grid?.container,
    paymentProfileDetailsGridItem: orderProps.grid?.item,
    payPalButtonGridItem: orderProps.grid?.item,
    creditCardAddressGridItem: {
        width: [12, 6, 6, 6, 6], // Store Custom Code
        css: css`
            flex-direction: column;
        `,
    },
    payPalButton: {
        container: {
            css: css`
                ${breakpoint("sm")} {
                    padding-top: ${formFieldButtonOffset()};
                }
            `,
        },
    },
    errorInfosBox: { type: "error" },
    loadingSpinner: {
        css: css`
            margin: auto;
        `,
    },
    adyenDropInGridItem: { width: 12 },
    /* Store Custom Code - Start */
    paymentMethodGridItem: checkoutInputGridItemStyle.gridItem,
    poNumberGridItem: checkoutInputGridItemStyle.gridItem,
    vatNumberGridItem: checkoutInputGridItemStyle.gridItem,
    emptyGridItem: checkoutInputGridItemStyle.gridItem,
    creditCardDetailsGridItem: checkoutInputGridItemStyle.gridItem,
    eCheckDetailsGridItem: checkoutInputGridItemStyle.gridItem,
    /* Store Custom Code - End */
};

declare const TokenEx: TokenExType;
let tokenExIframe: IFrame | undefined;
let tokenExAccountNumberIframe: IFrame | undefined;
let tokenExFrameStyleConfig: TokenExIframeStyles;
let spreedlyFrameStyleConfig: SpreedlyIframeStyles;

const isNonEmptyString = (value: string | undefined) => value !== undefined && value.trim() !== "";

const isMonthAndYearBeforeToday = (month: number, year: number) => {
    const today = new Date();
    const currentMonth = today.getMonth();
    const currentYear = today.getFullYear();
    return year < currentYear || (year === currentYear && month < currentMonth + 1);
};

const styles = checkoutReviewAndSubmitPaymentDetailsStyles;
const StyledForm = getStyledWrapper("form");
const StyledFieldSet = getStyledWrapper("fieldset");

const CheckoutReviewAndSubmitPaymentDetails = ({
    loadBillTo,
    cartState,
    billToState,
    cartSettings,
    tokenExConfigs,
    placeOrder,
    orderConfirmationPageLink,
    savedPaymentsPageLink,
    history,
    checkoutWithPayPal,
    payPalRedirectUri,
    preloadOrderConfirmationData,
    loadTokenExConfig,
    theme,
    session,
    checkoutReviewAndSubmitPageLink,
    location,
    toaster,
    paymetricConfig,
    loadPaymetricConfig,
    adyenSettings,
    loadAdyenSettings,
    loadAdyenDropInConfig,
    loadSpreedlyConfig,
    spreedlyConfig,
    getPaymetricResponsePacket,
    resetCurrentCartId,
    enableVat,
    bypassCvvForSavedCards,
    setCheckoutPaymentMethod,
    signInPageLink,
    placeOrderErrorMessage,
    signOut,
    requestedDeliveryDateDisabled,
    requestedPickUpDateDisabled,
    validateAdyenPayment,
    setPlaceOrderErrorMessage,
    setPaymetricIFrameIsSet,
    setPONumber,
    setValidateForm,
    // Starter Custom Code
    fields: { allowPromotionCode, cardExpirationDateCondensed },
    canApplyPromosToCart,
    // Bunzl
    isDisabled,
    isSignatureRequired,
    orderApprovalDetailsLink,
    placeOrderForApprovalWithOptionalPoNumber,
}: Props) => {
    /* Starter Custom Code */
    const trackAddPaymentInfo = ga.use.trackAddPaymentInfo({}, { cart: cartState.value });
    const trackAddShippingInfo = ga.use.trackAddShippingInfo({}, { cart: cartState.value });
    const setTrackPurchase = useCallback(() => {
        localStorage.setItem("trackPurchase", "track");
    }, []);
    /* Starter Custom Code */

    /* Store Custom Code - Start */
    const isMobileSalesAccount = useIsMobileSalesAccount();
    const hasSignature = !!useSignatureData().signatureData.customerSignature;

    /* Store Custom Code - End */

    const paymentDetailsFormState = usePaymentDetailsFormState();
    const {
        paymentMethod,
        setPaymentMethod,
        poNumber,
        setPONumber: localSetPoNumber,
        vatNumber,
        saveCard,
        cardHolderName,
        setCardHolderName,
        cardNumber,
        setCardNumber,
        cardType,
        setCardType,
        expirationMonth,
        setExpirationMonth,
        expirationYear,
        setExpirationYear,
        securityCode,
        setSecurityCode,
        useBillingAddress,
        setUseBillingAddress,
        address1,
        setAddress1,
        countryId,
        setCountryId,
        stateId,
        setStateId,
        city,
        setCity,
        postalCode,
        setPostalCode,
        paymentMethodError,
        poNumberError,
        address1Error,
        countryError,
        stateError,
        cityError,
        postalCodeError,
        payPalError,
        paystandError,
        setPaystandError,
        showFormErrors,
        setShowFormErrors,
        isCardNumberTokenized,
        setIsCardNumberTokenized,
        isECheckTokenized,
        setIsECheckTokenized,
        accountHolderName,
        setAccountHolderName,
        accountNumber,
        setAccountNumber,
        routingNumber,
        setRoutingNumber,
        payerId,
        setPayerId,
        creditCardLastFourDigits,
        setCreditCardLastFourDigits,
        bankAccountLastFourDigits,
        setBankAccountLastFourDigits,
        isIframeLoaded,
        setIsIframeLoaded,
        isPayPal,
        setIsPayPal,
        runSubmitPayPal,
        setRunSubmitPayPal,
        paymentMethodRef,
        poNumberRef,
        address1Ref,
        countryRef,
        stateRef,
        cityRef,
        postalCodeRef,
        maskedCardNumber,
        setMaskedCardNumber,
    } = paymentDetailsFormState;
    const paymentDetailsCartState = usePaymentDetailsCartState(cartState, paymentMethod, countryId);
    const {
        cart,
        useTokenExGateway,
        useECheckTokenExGateway,
        usePaymetricGateway,
        useSquareGateway,
        useAdyenDropIn,
        usePaystandDropIn,
        countries,
        showPayPal,
        paymentOptions,
        paymentMethods,
        paymentMethodDto,
        isCreditCard,
        isECheck,
        isPaymentProfile,
        selectedCountry,
        websiteSettings,
        useSpreedlyDropIn,
    } = paymentDetailsCartState;
    const paymentDetailsFormValidation = usePaymentDetailsFormValidation(
        paymentDetailsFormState,
        paymentDetailsCartState,
    );
    const {
        validatePaymentMethod,
        validatePONumber,
        validateAddress1,
        validateCountry,
        validateState,
        validateCity,
        validatePostalCode,
    } = paymentDetailsFormValidation;
    const {
        handlePaymentMethodChange,
        handlePONumberChange,
        handleVatNumberChange,
        handleSaveCardChange,
        handleCardHolderNameChange,
        handleCardNumberChange,
        handleCardTypeChange,
        handleExpirationMonthChange,
        handleExpirationYearChange,
        handleSecurityCodeChange,
        handleUseBillingAddressChange,
        handleAddressChange,
        handleCountryChange,
        handleStateChange,
        handleCityChange,
        handlePostalCodeChange,
        handleEditCardClick,
    } = usePaymentDetailsFormHandlers({
        paymentDetailsFormState,
        paymentDetailsFormValidation,
        paymentDetailsCartState,
        history,
        savedPaymentsPageLink,
        setPaymentMethodCallback: (
            event: React.ChangeEvent<HTMLSelectElement>,
            paymentMethods: PaymentMethodDto[] | null | undefined,
        ) => {
            setCheckoutPaymentMethod({
                paymentMethod: paymentMethods?.find(method => method.name === event.target.value),
            });
        },
    });

    const tokenExLibraryIsLoaded = useTokenExFrame();
    const spreedlyLibraryIsLoaded = useSpreedlyFrame();
    // will exist after we are redirected back here from paypal
    const {
        PayerID: payPalPayerId,
        token: payPalToken,
        redirectResult: adyenRedirectResult,
        cartId,
    } = parseQueryString<{
        PayerID?: string;
        token?: string;
        redirectResult?: string;
        cartId?: string;
    }>(location.search);

    useEffect(() => {
        if (!billToState.value && !billToState.isLoading && cartState.value && cartState.value.billToId) {
            loadBillTo({ billToId: cartState.value.billToId });
        }
    }, [billToState]);

    useEffect(() => {
        if (isCardNumberTokenized || isECheckTokenized) {
            placeOrder({
                paymentMethod,
                poNumber,
                vatNumber,
                saveCard,
                cardHolderName,
                cardNumber,
                cardType,
                expirationMonth,
                expirationYear,
                securityCode,
                useBillingAddress,
                address1,
                countryId,
                stateId,
                city,
                postalCode,
                payPalToken,
                payPalPayerId,
                accountHolderName,
                accountNumber,
                routingNumber,
                payerId,
                maskedCardNumber,
                onSuccess: (cartId: string) => {
                    /* Starter Custom Code */
                    trackAddShippingInfo();
                    trackAddPaymentInfo();
                    setTrackPurchase();
                    /* Starter Custom Code */
                    if (!orderConfirmationPageLink) {
                        return;
                    }

                    if (cart?.isAwaitingApproval) {
                        resetCurrentCartId({});
                        toaster.addToast({
                            body: siteMessage("OrderApproval_OrderPlaced"),
                            messageType: "success",
                        });
                    }

                    history.push(`${orderConfirmationPageLink.url}?cartId=${cartId}`);
                },
                onError: () => {
                    setIsCardNumberTokenized(false);
                    tokenExIframe?.reset();
                    if (usePaymetricGateway) {
                        // this will end up resetting the paymetric iframe
                        loadPaymetricConfig();
                    }

                    if (useSpreedlyDropIn) {
                        // this will end up resetting the Spreedly iframe
                        loadSpreedlyConfig();
                    }
                },
                onComplete(resultProps) {
                    if (resultProps.apiResult?.cart) {
                        // "this" is targeting the object being created, not the parent SFC
                        // eslint-disable-next-line react/no-this-in-sfc
                        this.onSuccess?.(resultProps.apiResult.cart.id);
                    } else {
                        // "this" is targeting the object being created, not the parent SFC
                        // eslint-disable-next-line react/no-this-in-sfc
                        this.onError?.();
                    }
                },
            });
        }
    }, [isCardNumberTokenized, isECheckTokenized]);

    useEffect(() => {
        if (!cartState.isLoading && cartState.value && cartState.value.paymentMethod && paymentMethod === "") {
            if (useAdyenDropIn && adyenRedirectResult) {
                // force set credit card payment method if we returned from Adyen
                setPaymentMethod(cartState.value.paymentOptions?.paymentMethods?.find(o => o.isCreditCard)?.name || "");
            } else {
                setPaymentMethod(cartState.value.paymentMethod.name);
            }
        }
    }, [cartState]);

    // IsPayPal
    // Setup isPayPal from cart.paymentOptions and validates form when cartState changes and is loaded.
    useEffect(() => {
        if (cartState.value) {
            const tempIsPayPal = cartState.value.paymentOptions?.isPayPal || (!!payPalToken && !!payPalPayerId);
            setIsPayPal(tempIsPayPal);
            if (tempIsPayPal) {
                validateForm();
            }
        }
    }, [cartState]);

    // Submit PayPal
    // When isPayPal and runSubmitPayPal are true will validate form, and submitPayPal with the current page redirectUri and current cart.
    useEffect(() => {
        if (isPayPal && runSubmitPayPal) {
            if (!validateForm()) {
                setShowFormErrors(true);
                return;
            }
            if (!checkoutReviewAndSubmitPageLink) {
                return;
            }
            let redirectUri = `${window.location.host}${checkoutReviewAndSubmitPageLink.url}`;
            if (cartId) {
                redirectUri += `?cartId=${cartId}`;
            }
            checkoutWithPayPal({ redirectUri });
        }
    }, [runSubmitPayPal, isPayPal]);

    // Submit PayPal State Check
    // Handles the PayPal button click response, getting the payPal redirectUri from the server on cart update call.
    useEffect(() => {
        if (payPalRedirectUri) {
            window.location.href = payPalRedirectUri;
        }
    }, [payPalRedirectUri]);

    const [adyenSessionId, setAdyenSessionId] = useState("");
    const [adyenSessionData, setAdyenSessionData] = useState("");
    const [adyenWebOrderNumber, setAdyenWebOrderNumber] = useState("");
    const [adyenRegion, setAdyenRegion] = useState("");
    const [adyenErrorMessage, setAdyenErrorMessage] = useState("");
    const [adyenConfiguration, setAdyenConfiguration] = useState<any>(null);
    const [adyenDropIn, setAdyenDropIn] = useState<any>(null);

    const isPaymentProfileExpired = paymentMethodDto?.isPaymentProfileExpired === true;
    let tokenName: string | undefined;
    const eCheckDetails = useRef<Validatable>(null);
    const creditCardDetails = useRef<CreditCardDetailsValidation>(null);
    const savedPaymentProfile = useRef<SavedPaymentProfileValidation>(null);

    if (useTokenExGateway) {
        if (isPaymentProfile) {
            tokenName = paymentMethodDto!.name;
        } else if (isCreditCard) {
            tokenName = "";
        }
    }

    if (useECheckTokenExGateway) {
        if (isECheck) {
            tokenName = "";
        }
    }

    const placeAdyenOrder = async (paymentResult: string) => {
        const { success, adyenPspReference, errorMessage, paymentAmount, currency } = await validateAdyenPayment({
            paymentResult,
        });
        if (!success) {
            if (adyenPspReference && paymentAmount && currency) {
                postAdyenRefund(adyenPspReference, adyenWebOrderNumber, paymentAmount, currency);
            }

            if (errorMessage) {
                setAdyenErrorMessage(errorMessage);
            }

            resetAdyenSession();
            return;
        }

        placeOrder({
            paymentMethod: "",
            poNumber: window.localStorage.getItem("order-po-number") ?? poNumber,
            vatNumber,
            saveCard,
            cardHolderName,
            cardNumber,
            cardType,
            expirationMonth,
            expirationYear,
            securityCode,
            useBillingAddress,
            address1,
            countryId,
            stateId,
            city,
            postalCode,
            payPalToken,
            payPalPayerId,
            isPending: true,
            isAdyenDropIn: true,
            adyenPspReference,
            accountHolderName,
            accountNumber,
            routingNumber,
            payerId,
            maskedCardNumber,
            onSuccess: (cartId: string) => {
                setTrackPurchase(); // Starter Custom Code
                preloadOrderConfirmationData({
                    cartId,
                    onSuccess: () => {
                        if (cart?.isAwaitingApproval) {
                            resetCurrentCartId({});
                            toaster.addToast({
                                body: siteMessage("OrderApproval_OrderPlaced"),
                                messageType: "success",
                            });
                        }
                        history.push(`${orderConfirmationPageLink!.url}?cartId=${cartId}`);
                    },
                });
            },
            onComplete(resultProps) {
                if (!resultProps.apiResult?.cart) {
                    return;
                }
                // "this" is targeting the object being created, not the parent SFC
                // eslint-disable-next-line react/no-this-in-sfc
                this.onSuccess?.(resultProps.apiResult.cart.id);
            },
        });
    };

    const resetAdyenSession = () => {
        setAdyenSessionId("");
        setAdyenSessionData("");
        setAdyenRegion("");
        setAdyenConfiguration(null);

        const parsedQuery = parseQueryString<any>(window.location.search);
        delete parsedQuery.customerId;
        delete parsedQuery.amount;
        delete parsedQuery.sessionId;
        delete parsedQuery.redirectResult;
        delete parsedQuery.type;
        delete parsedQuery.resultCode;
        const queryString = qs.stringify(parsedQuery);
        history.replace(`${window.location.pathname}${queryString !== "" ? `?${queryString}` : ""}`);
    };

    // Store Custom Code - populate poNumber from default PO number if its there -->
    useEffect(() => {
        if (cart && cart.poNumber && !poNumber) {
            localSetPoNumber(cart.poNumber);
        }
    }, [cart]);

    // <-- bunzl custom code
    useEffect(() => {
        let mounted = true;
        if (
            useAdyenDropIn &&
            paymentMethodDto?.isCreditCard &&
            checkoutReviewAndSubmitPageLink &&
            cartState.value?.orderGrandTotal &&
            !adyenSessionData
        ) {
            if (!adyenSettings?.clientKey) {
                loadAdyenSettings();
            }
            const returnUrl = !cartId
                ? checkoutReviewAndSubmitPageLink.url
                : checkoutReviewAndSubmitPageLink.url.includes("?")
                ? `${checkoutReviewAndSubmitPageLink.url}&cartId=${cartId}`
                : `${checkoutReviewAndSubmitPageLink.url}?cartId=${cartId}`;
            getAdyenSessionData(cartState.value.orderGrandTotal, returnUrl, cartId).then(result => {
                if (!mounted) {
                    return;
                }
                setAdyenSessionId(result.transactionId);
                setAdyenSessionData(result.sessionData);
                setAdyenWebOrderNumber(result.webOrderNumber);
                setAdyenRegion(result.region);
            });
        }
        return () => {
            mounted = false;
        };
    }, [useAdyenDropIn, checkoutReviewAndSubmitPageLink, cartState, paymentMethodDto, adyenSessionData]);

    useEffect(() => {
        if (adyenSessionId && adyenSessionData && adyenRegion && adyenSettings?.clientKey && !adyenConfiguration) {
            loadAdyenDropInConfig({
                sessionId: adyenSessionId,
                sessionData: adyenSessionData,
                region: adyenRegion,
                clientKey: adyenSettings.clientKey,
                cartId,
                webOrderNumber: adyenWebOrderNumber,
                returnUrl: !cartId
                    ? checkoutReviewAndSubmitPageLink!.url
                    : checkoutReviewAndSubmitPageLink!.url.includes("?")
                    ? `${checkoutReviewAndSubmitPageLink!.url}&cartId=${cartId}`
                    : `${checkoutReviewAndSubmitPageLink!.url}?cartId=${cartId}`,
                setAdyenErrorMessage,
                resetAdyenSession,
                placeAdyenOrder,
                onSuccess: (adyenConfiguration: any) => {
                    setAdyenConfiguration(adyenConfiguration);
                },
            });
        }
    }, [adyenSessionId, adyenSessionData, adyenRegion, adyenSettings]);

    useEffect(() => {
        setAdyenSessionId("");
        setAdyenSessionData("");
        setAdyenRegion("");
        setAdyenConfiguration(null);
    }, [cartState.value?.billToId]);

    useEffect(() => {
        if (typeof tokenName !== "undefined") {
            loadTokenExConfig({ token: tokenName, isECheck });
        }
    }, [paymentMethod]);

    useEffect(() => {
        if (useSpreedlyDropIn && !spreedlyConfig?.environmentKey) {
            loadSpreedlyConfig();
        }
    }, [paymentMethod]);

    const handleTokenExSessionExpired = (token: string) => {
        loadTokenExConfig({ token, isECheck });
    };

    const tokenExConfig = typeof tokenName !== "undefined" ? tokenExConfigs[tokenName] : undefined;

    const [paymetricFrameRef, paymetricIframe] = usePaymetricFrame(
        usePaymetricGateway,
        paymentMethod,
        isCreditCard,
        paymetricConfig,
        loadPaymetricConfig,
        setPaymetricIFrameIsSet,
    );

    const [paystandCard] = usePaystandFrame(websiteSettings, paymentMethod, isCreditCard);
    useEffect(() => {
        if (paystandCard.getIsPaystandScriptLoaded() && billToState.value) {
            paystandCard.setup(
                billToState.value,
                () => {
                    setIsIframeLoaded(true);
                },
                data => {
                    const isBillToUpdated = updateBillToCallback(
                        data.card?.billingAddress ?? data.bank?.billingAddress,
                    );
                    if (isBillToUpdated) {
                        toaster.addToast({
                            body: translate("Payment method submitted successfully"),
                            messageType: "success",
                        });
                        setCardNumber(data.id);
                        setPayerId(data.payerId);
                        setBankAccountLastFourDigits(data.bank?.last4);
                        setCreditCardLastFourDigits(data.card?.last4);
                        setPaystandError("");
                        setCardHolderName(data.card?.nameOnCard ?? data?.bank.nameOnAccount);
                        setCardType(data.card?.brand.toUpperCase() ?? data.bank?.bankName);
                        if (data.card) {
                            setExpirationMonth(parseInt(data.card.expirationMonth, 10));
                            setExpirationYear(parseInt(data.card.expirationYear, 10));
                            setCreditCardLastFourDigits(data.card.last4);
                            setMaskedCardNumber(data.card.last4);
                        }
                    } else {
                        setShowFormErrors(true);
                        setPaystandError(
                            translate("Selected country isn't supported. Please re-enter payment details."),
                        );
                    }
                },
            );
        }
    }, [paystandCard.getIsPaystandScriptLoaded(), paymentMethod]);

    const updateBillToCallback = (address: BillingAddress): boolean => {
        const country = countries?.find(
            o =>
                o.name === address.country ||
                o.abbreviation === address.country ||
                o.states?.find(o => o.name === address.state || o.abbreviation === address.state),
        );

        if (country) {
            setCountryId(country.id);
            const state = country.states?.find(o => o.name === address.state || o.abbreviation === address.state);
            if (state) {
                setStateId(state.id);
            }
        } else {
            return false;
        }

        setUseBillingAddress(false);
        setAddress1(address.street1);
        setCity(address.city);
        setPostalCode(address.postalCode);

        return true;
    };

    const [squareCard] = useSquareFrame(websiteSettings, paymentMethod, isCreditCard);

    const tokenizeSquareCard = () => {
        squareCard?.tokenize().then((tokenResult: any) => {
            if (tokenResult.status === "OK") {
                setCardType(tokenResult.details.card.brand);
                setExpirationMonth(tokenResult.details.card.expMonth);
                setExpirationYear(tokenResult.details.card.expYear);
                setCardNumber(tokenResult.token);
                setIsCardNumberTokenized(true);
            }
        });
    };

    const toasterContext = React.useContext(ToasterContext);
    useEffect(() => {
        if (placeOrderErrorMessage === siteMessage("CreditCardInfo_MaximumCreditCardAttempts")) {
            toasterContext.addToast({
                body: placeOrderErrorMessage,
                messageType: "danger",
            });

            setTimeout(() => {
                signOut();
                signInPageLink && history.push(signInPageLink.url);
            }, 3000);
        }
    }, [placeOrderErrorMessage]);

    const handleAccountNumberIFrame = (accountNumberIFrame: IFrame) => {
        tokenExAccountNumberIframe = accountNumberIFrame;
    };

    const handlePaymetricValidateSuccess = (success: boolean) => {
        if (success) {
            paymetricIframe.submit({
                onSuccess: (msg: string) => {
                    // The HasPassed is case sensitive, and not standard json.
                    const message: { data: { HasPassed: boolean } } = JSON.parse(msg);
                    if (message.data.HasPassed) {
                        handleSuccessSubmitPaymetricIframe();
                    }
                },
                onError: (msg: string) => {
                    const message: { data: { Code: number; HasPasssed: boolean; Message: string } } = JSON.parse(msg);
                    // Code = 150 -> Already submitted
                    if (message.data.Code === 150) {
                        handleSuccessSubmitPaymetricIframe();
                    }

                    if (!message.data.HasPasssed) {
                        if (message.data.Message === "Error" && message.data.Code === 100) {
                            setPlaceOrderErrorMessage({
                                errorMessage: siteMessage("Checkout_Paymetric_Code_100_Error") as string,
                            });
                        } else if (message.data.Message && message.data.Message !== "Error") {
                            setPlaceOrderErrorMessage({
                                // eslint-disable-next-line spire/avoid-dynamic-translate
                                errorMessage: translate(message.data.Message),
                            });
                        }
                    }
                },
            });
        }
    };

    const handleSuccessSubmitPaymetricIframe = () => {
        if (!paymetricConfig?.accessToken) {
            return;
        }

        getPaymetricResponsePacket({
            accessToken: paymetricConfig.accessToken,
            onComplete: result => {
                if (result.apiResult?.success) {
                    setCardType(convertPaymetricCardType(result.apiResult.creditCard.cardType));
                    setExpirationMonth(result.apiResult.creditCard.expirationMonth!);
                    setExpirationYear(result.apiResult.creditCard.expirationYear!);
                    setCardNumber(result.apiResult.creditCard.cardNumber!);
                    setSecurityCode(result.apiResult.creditCard.securityCode!);
                    setCardHolderName(result.apiResult.creditCard.cardHolderName!);
                    setIsCardNumberTokenized(true);
                }
            },
        });
    };
    /* Store Custom Code - Start */
    const validateSignature = () => {
        if (!isMobileSalesAccount) {
            return true;
        }
        if (isSignatureRequired && !hasSignature) {
            return false;
        }
        return true;
    };
    const signatureErrors = hasSignature ? "" : translate("Signature is required.");
    /* Store Custom Code - End */
    const validateForm = () => {
        const paymentMethodValid = validatePaymentMethod(paymentMethod);
        const poNumberValid = validatePONumber(poNumber);
        // Store Custom Code
        const signatureValid = validateSignature();

        // Bunzl -->
        if (isDisabled) {
            return false;
        }
        // <-- Bunzl

        if (isPayPal) {
            return paymentMethodValid;
        }

        if (useAdyenDropIn && paymentMethodDto?.isCreditCard) {
            return poNumberValid;
        }

        if (useTokenExGateway && ((isPaymentProfile && !bypassCvvForSavedCards) || isCreditCard)) {
            tokenExIframe?.validate();
        } else if (useECheckTokenExGateway && isECheck) {
            tokenExAccountNumberIframe?.validate();
        }

        if (usePaymetricGateway && cart && cart.showCreditCard && !cart.requiresApproval) {
            const isFormValidForPaymetricPayment = paymentMethodValid && poNumberValid;
            if (!isFormValidForPaymetricPayment) {
                return false;
            }
            if (isCreditCard && paymetricIframe) {
                paymetricIframe.validate({
                    onValidate: (success: boolean) => {
                        handlePaymetricValidateSuccess(success);
                    },
                });
            } else if (isPaymentProfile) {
                if (savedPaymentProfile?.current) {
                    return savedPaymentProfile?.current.validate();
                }

                return true;
            }
        }

        if (useSquareGateway && cart && cart.showCreditCard && !cart.requiresApproval) {
            const isFormValidForSquarePayment = paymentMethodValid && poNumberValid;
            if (!isFormValidForSquarePayment) {
                return false;
            }
            if (isCreditCard && squareCard) {
                tokenizeSquareCard();
            } else if (isPaymentProfile) {
                return true;
            }
        }

        if (usePaystandDropIn && isCreditCard && cart && cart.showCreditCard && !cart.requiresApproval) {
            const isTokenExist = !!payerId && !!cardNumber;
            setPaystandError(!isTokenExist ? translate("Payment details are required.") : "");
            return isTokenExist;
        }

        const address1Valid = validateAddress1(address1);
        const countryValid = validateCountry(countryId);
        const stateValid = validateState(stateId);
        const cityValid = validateCity(city);
        const postalCodeValid = validatePostalCode(postalCode);
        let accountHolderNameValid = true;
        let accountNumberValid = true;
        let routingNumberValid = true;
        if (eCheckDetails?.current) {
            accountHolderNameValid = eCheckDetails.current.validateAccountHolderNameChange(accountHolderName);
            accountNumberValid = eCheckDetails.current.validateAccountNumberChange(accountNumber);
            routingNumberValid = eCheckDetails.current.validateRoutingNumberChange(routingNumber);
        }
        let creditCardValid = true;
        if (creditCardDetails?.current) {
            creditCardValid = creditCardDetails.current.validate();
        }

        if (savedPaymentProfile?.current) {
            creditCardValid = savedPaymentProfile?.current.validate();
        }

        if (!paymentMethodValid) {
            paymentMethodRef.current?.focus();
        } else if (!poNumberValid) {
            poNumberRef.current?.focus();
        } else if (!address1Valid) {
            address1Ref.current?.focus();
        } else if (!countryValid) {
            countryRef.current?.focus();
        } else if (!stateValid) {
            stateRef.current?.focus();
        } else if (!cityValid) {
            cityRef.current?.focus();
        } else if (!postalCodeValid) {
            postalCodeRef.current?.focus();
        }

        return (
            paymentMethodValid &&
            /* Store Custom Code */
            signatureValid &&
            poNumberValid &&
            creditCardValid &&
            address1Valid &&
            countryValid &&
            stateValid &&
            cityValid &&
            postalCodeValid &&
            accountHolderNameValid &&
            accountNumberValid &&
            routingNumberValid &&
            !requestedDeliveryDateDisabled &&
            !requestedPickUpDateDisabled
        );
    };

    const handleFormSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        trackAddPaymentInfo(); // Starter Custom Code
        /* Store Custom Code - Start */
        if (cart?.requiresApproval) {
            placeOrderForApprovalWithOptionalPoNumber({
                poNumber,
                onSuccess: (cartId: string) => {
                    if (orderApprovalDetailsLink) {
                        history.push(`${orderApprovalDetailsLink.url}?cartId=${cartId}`);
                    } else {
                        toaster.addToast({
                            body: translate("Order approval details page doesn't exist."),
                            messageType: "danger",
                        });
                    }
                },
                onComplete(resultProps) {
                    if (resultProps.apiResult?.cart.id) {
                        // "this" is targeting the object being created, not the parent SFC
                        // eslint-disable-next-line react/no-this-in-sfc
                        this.onSuccess?.(resultProps.apiResult.cart.id);
                    }
                },
            });

            return false;
        }
        /* Store Custom Code - End */
        if (document.activeElement?.className === "adyen-checkout__payment-method__header__title") {
            // The adyen form buttons are incorrectly submitting our form, we should just ignore these occurances.
            return false;
        }

        if (!validateForm()) {
            setShowFormErrors(true);
            /* Store Custom Code */
            if (showFormErrors === true) {
                const errorBoxElement = document.querySelector(`[id^="form-error-wrapper-"]`);
                if (errorBoxElement instanceof HTMLElement) {
                    errorBoxElement.scrollIntoView();
                }
            }
            /* Store Custom Code */
            return false;
        }

        if (useAdyenDropIn && isCreditCard && !isPayPal) {
            if (adyenDropIn) {
                const { success, errorMessage } = await validateAdyenPayment({
                    customerId: cartState.value?.billToId,
                    paymentAmount: cartState.value?.orderGrandTotal,
                });
                if (success) {
                    window.localStorage.setItem("order-po-number", poNumber);
                    adyenDropIn.submit();
                } else if (errorMessage) {
                    setAdyenErrorMessage(errorMessage);
                }
            }
        } else if (useTokenExGateway && ((isPaymentProfile && !bypassCvvForSavedCards) || isCreditCard)) {
            creditCardDetails.current?.tokenize();
            savedPaymentProfile.current?.tokenize();
        } else if (useSpreedlyDropIn && isCreditCard) {
            creditCardDetails.current?.tokenize();
        } else if (useECheckTokenExGateway && !isPayPal && isECheck) {
            tokenExAccountNumberIframe?.tokenize();
        } else {
            placeOrder({
                paymentMethod,
                poNumber,
                vatNumber,
                saveCard,
                cardHolderName,
                cardNumber,
                cardType,
                expirationMonth,
                expirationYear,
                securityCode,
                useBillingAddress,
                address1,
                countryId,
                stateId,
                city,
                postalCode,
                payPalToken,
                payPalPayerId,
                accountHolderName,
                accountNumber,
                routingNumber,
                payerId,
                maskedCardNumber,
                onSuccess: (cartId: string) => {
                    setTrackPurchase(); // Starter Custom Code
                    preloadOrderConfirmationData({
                        cartId,
                        onSuccess: () => {
                            if (cart?.isAwaitingApproval) {
                                resetCurrentCartId({});
                                toaster.addToast({
                                    body: siteMessage("OrderApproval_OrderPlaced"),
                                    messageType: "success",
                                });
                            }
                            history.push(`${orderConfirmationPageLink!.url}?cartId=${cartId}`);
                        },
                    });
                },
                onComplete(resultProps) {
                    if (!resultProps.apiResult?.cart) {
                        return;
                    }
                    // "this" is targeting the object being created, not the parent SFC
                    // eslint-disable-next-line react/no-this-in-sfc
                    this.onSuccess?.(resultProps.apiResult.cart.id);
                },
            });
        }

        return false;
    };

    const submitPayPalRequest = (event: React.MouseEvent<HTMLAnchorElement>) => {
        event.preventDefault();
        if (!checkoutReviewAndSubmitPageLink) {
            return;
        }
        if (!session?.isAuthenticated) {
            return;
        }
        setPaymentMethod("");
        setRunSubmitPayPal(true);
        setIsPayPal(true);
    };

    const handleResetPaymentMethodClick = () => {
        if (usePaystandDropIn) {
            paystandCard.resetCheckout(billToState.value!);
        }
    };

    if (!tokenExFrameStyleConfig) {
        tokenExFrameStyleConfig = generateTokenExFrameStyleConfig({ theme });
    }

    if (!spreedlyFrameStyleConfig && useSpreedlyDropIn) {
        spreedlyFrameStyleConfig = generateSpreedlyFrameStyleConfig({ theme });
    }

    if (
        !cart ||
        // Store Custom Code
        // cart.requiresApproval ||
        !paymentOptions ||
        !orderConfirmationPageLink ||
        (useTokenExGateway && !tokenExLibraryIsLoaded) ||
        (useSpreedlyDropIn && !spreedlyLibraryIsLoaded)
    ) {
        return null;
    }

    const iframeName = useTokenExGateway
        ? "TokenEx"
        : usePaymetricGateway
        ? "Paymetric"
        : useSquareGateway
        ? "Square"
        : usePaystandDropIn
        ? "Paystand"
        : useSpreedlyDropIn
        ? "Spreedly"
        : undefined;

    const paymentDetailsStyles = usePaystandDropIn ? styles.paystandDetailsGridItem : styles.creditCardDetailsGridItem;

    return (
        <Block {...styles.block /* Starter Custom Code */}>
            <StyledForm
                {...styles.form}
                id="reviewAndSubmitPaymentForm"
                onSubmit={handleFormSubmit}
                noValidate={true}
                data-test-selector="reviewAndSubmitPaymentForm"
            >
                {/* This button should only be used to trigger the submit of the form. Should be on the top of the form. */}
                <button id="reviewAndSubmitPaymentForm-submit" type="submit" style={{ display: "none" }}>
                    {translate("Place Order")}
                </button>
                <StyledFieldSet {...styles.fieldset}>
                    <Typography {...styles.paymentDetailsHeading /* Bunzl Removed Code - h2 */}>
                        {translate("Payment Details")}
                    </Typography>
                    {isPayPal && (
                        <Typography {...styles.paymentMethodPayPalText} as="span">
                            {translate("Selected Payment Method: PayPal")}
                        </Typography>
                    )}
                    {!isPayPal && (
                        <>
                            {/* Starter Custom Code - Start */}
                            {paymentMethodDto?.isPaymentProfile && paymentMethodDto.isPaymentProfileExpired && (
                                <InfosBox {...styles.errorInfosBox}>
                                    {siteMessage("Checkout_PaymentProfileExpired")}{" "}
                                    {savedPaymentsPageLink && (
                                        <Link {...styles.paymentProfileEditCardLink} onClick={handleEditCardClick}>
                                            {translate("Edit Card")}
                                        </Link>
                                    )}
                                </InfosBox>
                            )}
                            {/* Starter Custom Code - End */}
                            <StyledWrapper {...styles.subSection} /* Starter Custom Code */>
                                <GridContainer {...styles.paymentMethodAndPONumberContainer}>
                                    <GridItem {...styles.paymentMethodGridItem}>
                                        {/* Store Custom Code */}
                                        {paymentMethods && paymentMethods.length > 0 && (
                                            <StyledWrapper {...styles.gridRow}>
                                                <Select
                                                    {...styles.paymentMethodSelect}
                                                    label={translate("Payment Method")}
                                                    value={paymentMethod ?? paymentMethodDto?.name}
                                                    onChange={handlePaymentMethodChange}
                                                    required
                                                    error={showFormErrors && paymentMethodError}
                                                    data-test-selector="checkoutReviewAndSubmit_paymentMethod"
                                                    ref={paymentMethodRef}
                                                    // Store Custom Code
                                                    disabled={paymentMethods.length <= 1}
                                                >
                                                    {/* Store Custom Code */}
                                                    {paymentMethods.length > 1 ? (
                                                        <option value="">{translate("Select Payment Method")}</option>
                                                    ) : null}
                                                    {/* Store Custom Code */}
                                                    {paymentMethods.map(method => (
                                                        <option key={method.name} value={method.name}>
                                                            {/* Starter Custom Code - Start */}
                                                            {method.isPaymentProfile
                                                                ? `${translate("Credit Card")}${translate(":")} ${
                                                                      method.description || method.name
                                                                  }`
                                                                : method.description || method.name}
                                                            {/* Starter Custom Code - End */}
                                                        </option>
                                                    ))}
                                                </Select>
                                                {/* Starter Moved - PaymentProfileBillingAddress - down */}
                                                {/* Starter Moved - paymentProfileExpiredErrorText - up */}
                                            </StyledWrapper>
                                        )}
                                    </GridItem>
                                    {showPayPal && (
                                        <GridItem {...styles.payPalButtonGridItem} /* Starter Custom Code */>
                                            <PayPalButton
                                                extendedStyles={styles.payPalButton}
                                                submitPayPalRequest={submitPayPalRequest}
                                                error={showFormErrors ? payPalError : undefined}
                                            ></PayPalButton>
                                        </GridItem>
                                    )}
                                    {enableVat && (
                                        <GridItem {...styles.vatNumberGridItem}>
                                            <TextField
                                                {...styles.vatNumberText}
                                                label={translate("VAT Number")}
                                                value={vatNumber}
                                                onChange={handleVatNumberChange}
                                                maxLength={50}
                                                data-test-selector="checkoutReviewAndSubmit_vatNumber"
                                            />
                                        </GridItem>
                                    )}
                                    {/* Store Custom Code - Start */}
                                    {isSignatureRequired && (
                                        <VisuallyHidden>
                                            <TextField error={showFormErrors ? signatureErrors : undefined} />
                                            <label htmlFor="signatureRequired">{translate("Signature Required")}</label>
                                        </VisuallyHidden>
                                    )}
                                    {/* Store Custom Code - End */}
                                    {cart.showPoNumber && (
                                        <GridItem {...styles.poNumberGridItem}>
                                            <StyledWrapper {...styles.gridRow}>
                                                <TextField
                                                    {...styles.poNumberText}
                                                    label={
                                                        <>
                                                            <span aria-hidden>{translate("PO Number")}</span>
                                                            <VisuallyHidden>
                                                                {translate("Purchase Order Number")}
                                                            </VisuallyHidden>
                                                        </>
                                                    }
                                                    value={poNumber}
                                                    onChange={handlePONumberChange}
                                                    required={cart.requiresPoNumber}
                                                    maxLength={50}
                                                    error={showFormErrors && poNumberError}
                                                    data-test-selector="checkoutReviewAndSubmit_poNumber"
                                                    ref={poNumberRef}
                                                    hint={siteMessage("Checkout_PONumberInformation")}
                                                />
                                            </StyledWrapper>
                                        </GridItem>
                                    )}
                                    {/* Starter Custom Code - Start */}
                                    {allowPromotionCode && canApplyPromosToCart && (
                                        <GridItem {...styles.promotionCodeGridItem}>
                                            <PromotionCode />
                                        </GridItem>
                                    )}
                                    {/* Starter Custom Code - End */}
                                </GridContainer>
                            </StyledWrapper>
                            {paymentMethodDto?.isPaymentProfile &&
                                !paymentMethodDto.isPaymentProfileExpired &&
                                !bypassCvvForSavedCards && (
                                    <StyledWrapper {...styles.subSection} /* Starter Custom Code */>
                                        <Typography {...styles.paymentProfileDetailsHeading} /* Starter Custom Code */>
                                            {translate("Credit Card Details")}
                                        </Typography>
                                        <GridContainer
                                            {...styles.paymentProfileDetailsContainer} /* Starter Custom Code */
                                        >
                                            <GridItem
                                                {...styles.paymentProfileDetailsGridItem} /* Starter Custom Code */
                                            >
                                                <SavedPaymentProfileEntry
                                                    iframe={iframeName}
                                                    onSecurityCodeUpdate={handleSecurityCodeChange}
                                                    extendedStyles={styles.savedPaymentProfile}
                                                    tokenExConfig={tokenExConfig}
                                                    tokenExFrameStyleConfig={tokenExFrameStyleConfig}
                                                    paymentMethodDto={paymentMethodDto}
                                                    updateCardIsTokenized={setIsCardNumberTokenized}
                                                    ref={savedPaymentProfile}
                                                />
                                            </GridItem>
                                        </GridContainer>
                                    </StyledWrapper>
                                )}
                            {paymentMethodDto?.isCreditCard && useAdyenDropIn && (
                                <StyledWrapper {...styles.subSection} /* Starter Custom Code */>
                                    <Typography {...styles.creditCardDetailsHeading} /* Starter Custom Code */>
                                        {translate("Credit Card Details")}
                                    </Typography>
                                    {!adyenDropIn && !showPayPal && <Loader /> /* Starter Custom Code */}
                                    <AdyenDropIn
                                        redirectResult={adyenRedirectResult}
                                        adyenConfiguration={adyenConfiguration}
                                        setAdyenDropIn={setAdyenDropIn}
                                        adyenErrorMessage={adyenErrorMessage}
                                    />
                                </StyledWrapper>
                            )}
                            {cart.showCreditCard && paymentMethodDto?.isCreditCard && !useAdyenDropIn && (
                                <StyledWrapper {...styles.subSection} /* Starter Custom Code */>
                                    <CreditCardDetailsEntry
                                        canSaveCard={paymentOptions.canStorePaymentProfile}
                                        iframe={iframeName}
                                        paymetricFrameRef={paymetricFrameRef}
                                        onSaveCardUpdate={handleSaveCardChange}
                                        onCardHolderNameUpdate={handleCardHolderNameChange}
                                        onCardNumberUpdate={handleCardNumberChange}
                                        onCardTypeUpdate={handleCardTypeChange}
                                        onExpirationMonthUpdate={handleExpirationMonthChange}
                                        onExpirationYearUpdate={handleExpirationYearChange}
                                        onSecurityCodeUpdate={handleSecurityCodeChange}
                                        availableCardTypes={paymentOptions.cardTypes ?? []}
                                        availableMonths={paymentOptions.expirationMonths ?? []}
                                        availableYears={paymentOptions.expirationYears ?? []}
                                        extendedStyles={styles.creditCardDetails}
                                        onResetPaymentMethodClick={handleResetPaymentMethodClick}
                                        isIframeLoaded={isIframeLoaded}
                                        error={showFormErrors ? paystandError : undefined}
                                        bankAccountLastFourDigits={bankAccountLastFourDigits}
                                        creditCardLastFourDigits={creditCardLastFourDigits}
                                        tokenExConfig={tokenExConfig}
                                        spreedlyConfig={spreedlyConfig}
                                        tokenExFrameStyleConfig={tokenExFrameStyleConfig}
                                        spreedlyFrameStyleConfig={spreedlyFrameStyleConfig}
                                        updateCardIsTokenized={setIsCardNumberTokenized}
                                        updateMaskedCardNumber={setMaskedCardNumber}
                                        ref={creditCardDetails}
                                    />
                                </StyledWrapper>
                            )}
                            {cart.showECheck && paymentMethodDto?.isECheck && (
                                <StyledWrapper {...styles.subSection} /* Starter Custom Code */>
                                    <ECheckDetailsEntry
                                        iframe={useECheckTokenExGateway ? "TokenEx" : undefined}
                                        paymentMethod={paymentMethod}
                                        onAccountHolderNameChange={setAccountHolderName}
                                        onAccountNumberChange={setAccountNumber}
                                        onRoutingNumberChange={setRoutingNumber}
                                        tokenExConfig={tokenExConfig}
                                        tokenExFrameStyleConfig={tokenExFrameStyleConfig}
                                        extendedStyles={styles.eCheckDetailsEntryStyles}
                                        showFormErrors={showFormErrors}
                                        updateIsECheckTokenized={setIsECheckTokenized}
                                        updateShowFormErrors={setShowFormErrors}
                                        setAccountNumberIFrame={handleAccountNumberIFrame}
                                        ref={eCheckDetails}
                                    />
                                </StyledWrapper>
                            )}
                            {((cart.showECheck && paymentMethodDto?.isECheck) ||
                                (cart.showCreditCard &&
                                    paymentMethodDto?.isCreditCard &&
                                    !useAdyenDropIn &&
                                    !usePaystandDropIn)) && (
                                <StyledWrapper {...styles.subSection} /* Starter Custom Code */>
                                    <CreditCardBillingAddressEntry
                                        useBillTo={useBillingAddress}
                                        onUseBillToChange={handleUseBillingAddressChange}
                                        billTo={billToState.value}
                                        address1={address1}
                                        address1Ref={address1Ref}
                                        onAddress1Change={handleAddressChange}
                                        address1Error={showFormErrors ? address1Error : undefined}
                                        country={countryId}
                                        countryRef={countryRef}
                                        onCountryChange={handleCountryChange}
                                        countryError={showFormErrors ? countryError : undefined}
                                        state={stateId}
                                        stateRef={stateRef}
                                        onStateChange={handleStateChange}
                                        stateError={showFormErrors ? stateError : undefined}
                                        city={city}
                                        cityRef={cityRef}
                                        onCityChange={handleCityChange}
                                        cityError={showFormErrors ? cityError : undefined}
                                        postalCode={postalCode}
                                        postalCodeRef={postalCodeRef}
                                        onPostalCodeChange={handlePostalCodeChange}
                                        postalCodeError={showFormErrors ? postalCodeError : undefined}
                                        availableCountries={countries ?? []}
                                        availableStates={selectedCountry?.states}
                                        extendedStyles={styles.creditCardAddress}
                                    />
                                </StyledWrapper>
                            )}
                            {/* Starter Custom Code - Start */}
                            {paymentMethodDto?.isPaymentProfile && !paymentMethodDto.isPaymentProfileExpired ? (
                                <StyledWrapper {...styles.subSection}>
                                    <Typography {...styles.paymentProfileAddressHeading}>
                                        {translate("Credit Card Address")}
                                    </Typography>
                                    <PaymentProfileBillingAddress
                                        address={paymentMethodDto.billingAddress}
                                        extendedStyles={styles.paymentProfileBillingAddress}
                                    />
                                </StyledWrapper>
                            ) : null}
                        </>
                    )}
                    {/* Starter Custom Code - End */}
                </StyledFieldSet>
            </StyledForm>
        </Block>
    );
};

const widgetModule: WidgetModule = {
    component: connect(
        mapStateToProps,
        mapDispatchToProps,
    )(withToaster(withHistory(withTheme(CheckoutReviewAndSubmitPaymentDetails)))),
    definition: {
        group: "Checkout - Review & Submit",
        displayName: "Payment Details",
        allowedContexts: ["CheckoutReviewAndSubmitPage"],
        /* Starter Custom Code */
        fieldDefinitions: [
            {
                name: fields.allowPromotionCode,
                displayName: "Allow Promotion Code",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
            },
            {
                name: fields.cardExpirationDateCondensed,
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
            },
        ],
        /* Starter Custom Code */
    },
};

export default widgetModule;
